import { HeaderTwoColumnLayoutSkeleton } from 'layouts';

const PublicEventSkeleton = () => (
  <HeaderTwoColumnLayoutSkeleton
    header={{ paragraph: { rows: 10 } }}
    left={[{ paragraph: { rows: 4 } }]}
    right={[{ paragraph: { rows: 4 } }, { paragraph: { rows: 6 } }]}
  />
);

export default PublicEventSkeleton;
